import { Component } from 'react';
import { Navigate } from 'react-router-dom';

import { Box, Button } from '@mui/material';

import { withTranslation } from 'react-i18next';
// import i18n from '../assets/locales';

import Layout from '../layouts/layout.component';


type Props = {};

type State = {
  redirect: string | null,
};


class RegisterRquirement extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      redirect: null,
    };
  }
  
  componentDidMount() {
    
  }

  componentWillUnmount() {
    
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }
    
    return (
      <Layout>
        <div style={{ padding: 20 }}>
          <h1>Registration Requirement Verification</h1>
          <Box sx={{ height: 20 }} />
          <p>
            To ensure the security and integrity of our platform, we require all users to verify their email address during the registration process. This verification step helps us confirm that the email address provided is valid and belongs to the user registering for an account.
          </p>
          <p>
            After you complete the registration form and submit your information, you will receive an automated email containing a verification link. Please click on the link in the email to verify your email address and complete the registration process.
          </p>
          <p>
            If you do not receive the verification email within a few minutes, please check your spam or junk folder. If you still cannot find the email, please contact our support team for assistance.
          </p>
          <Box sx={{ height: 20 }} />
          <Button variant='contained' color='primary' onClick={() => this.setState({ redirect: '/signin' })}>
            Proceed to Sign In
          </Button>
        </div>
      </Layout>
    );
  }
}

export default withTranslation()(RegisterRquirement);
